const imgUrl = {
  // 改用bind和update钩子函数，这在Vue2中更可靠
  bind(el, binding) {
    updateImgSrc(el)
  },
  update(el, binding) {
    updateImgSrc(el)
  }
}

// 抽取公共处理函数
function updateImgSrc(el) {
  const imgSrc = el.getAttribute('src')
  if (!imgSrc) {
    el.setAttribute('src', require('@/assets/images/empty.png'))
    return
  }
  
  if (!imgSrc.startsWith('http')) {
    el.setAttribute('src', `${process.env.VUE_APP_BASE_URL}${imgSrc}`)
  }
}

export default imgUrl